import React from 'react';

import { useSuperAdminUserProfileActivityQuery } from 'generated/graphql';
import { useLoading } from 'modules';



export interface IData {
  fullName: string;
  email: string;
}

export function useUserProfileActivity() {
  const tuple = useSuperAdminUserProfileActivityQuery();
  const loading = useLoading([tuple]);



  const data = React.useMemo((): IData => ({
    fullName: `${tuple.data?.loggedInUser?.firstName ?? ''} ${tuple.data?.loggedInUser?.lastName ?? ''}`,
    email: tuple.data?.loggedInUser?.email ?? ''
  }), [tuple]);



  return {
    data,
    loading
  };
}
